// extracted by mini-css-extract-plugin
export default {"Wrapper":"SurveyRecordView_Wrapper__3qOpJ","Content":"SurveyRecordView_Content__XKUWT"};